import React, { Component } from "react";

import "../styles/job-footer.css";

class JobFooter extends Component {
  render() {
    return (
      <div className="job-footer">
        <div className="container">
          ©DevStack {new Date().getFullYear()} All Rights Reserved
        </div>
      </div>
    );
  }
}

export default JobFooter;



// WEBPACK FOOTER //
// ./src/components/jobFooter.js